export default class Clipboard {
  private static textArea: any;

  public static copy(text: string): void {
    this.createTextArea(text);
    this.selectText();
    this.copyToClipboard();
  }

  private static isOS() {
    return navigator.userAgent.match(/ipad|iphone/i);
  }

  private static createTextArea(text: string): void {
    this.textArea = document.createElement('textArea');
    this.textArea.value = text;
    document.body.appendChild(this.textArea);
  }

  private static selectText() {
    let range, selection;

    if (this.isOS()) {
      range = document.createRange();
      range.selectNodeContents(this.textArea);
      selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      this.textArea.setSelectionRange(0, 999999);
    } else {
      this.textArea.select();
    }
  }

  private static copyToClipboard(): void {
    document.execCommand('copy');
    document.body.removeChild(this.textArea);
  }
}
